/*
 * Microsoft Clarity: custom events, funnel tags, and masking for personal fields.
 * Clarity itself is loaded by the Microsoft Clarity app embed; this file only calls
 * window.clarity(). Calls made before Clarity has loaded are held and sent once it has.
 *
 * Events: add_to_cart, checkout_clicked, delivery_week_selected, quantity_changed,
 * cart_item_removed, cart_drawer_opened. Funnel: tag "funnel_stage" plus a
 * funnel_<stage> event once per page view.
 *
 * Checkout pages are hosted by Shopify and are not part of the theme. Their masking and
 * events come from the Clarity app and the Clarity dashboard settings.
 */
(function () {
  if (window.__mhClarityEvents) return;
  window.__mhClarityEvents = true;

  var pending = [];
  var flushTimer = null;
  var flushTries = 0;
  var recent = {};

  function flush() {
    if (typeof window.clarity !== 'function') return false;
    while (pending.length) {
      var args = pending.shift();
      try { window.clarity.apply(window, args); } catch (err) {}
    }
    return true;
  }

  function send() {
    pending.push(Array.prototype.slice.call(arguments));
    if (flush() || flushTimer) return;
    flushTimer = setInterval(function () {
      flushTries += 1;
      if (flush() || flushTries > 40) {
        clearInterval(flushTimer);
        flushTimer = null;
        if (flushTries > 40) pending.length = 0;
      }
    }, 500);
  }

  function track(name, tags) {
    // Collapse the duplicate signals one user action can produce (click plus change).
    var now = Date.now();
    if (recent[name] && now - recent[name] < 400) return;
    recent[name] = now;
    send('event', name);
    if (tags) {
      Object.keys(tags).forEach(function (key) {
        if (tags[key] != null && tags[key] !== '') send('set', key, String(tags[key]));
      });
    }
  }

  window.MHClarity = { track: track };

  /* Funnel stage for the page being viewed. */
  function pageStage() {
    var match = /\btemplate-([a-z0-9-]+)/.exec(document.body ? document.body.className : '');
    var template = match ? match[1] : '';
    if (template === 'index') return 'home';
    if (template === 'collection') return 'collection_view';
    if (template === 'product') return 'product_view';
    if (template === 'cart') return 'cart_view';
    return '';
  }

  function trackPageStage() {
    var stage = pageStage();
    if (!stage) return;
    send('set', 'funnel_stage', stage);
    send('event', 'funnel_' + stage);
  }

  /* Add to cart: every cart update that comes from a product form or the drawer upsell. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var source = event && event.source;
      if (source === 'product-form' || source === 'drawer-upsell') {
        track('add_to_cart', { last_add_source: source });
      }
    });
  }

  function closestSafe(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    if (closestSafe(target, 'button[name="checkout"], input[name="checkout"], #CartDrawer-Checkout, #checkout')) {
      track('checkout_clicked');
      send('set', 'funnel_stage', 'checkout_clicked');
      return;
    }

    if (closestSafe(target, 'cart-remove-button')) {
      track('cart_item_removed');
      return;
    }

    var qty = closestSafe(target, '.quantity__button.qtyplus, .quantity__button.qtyminus');
    if (qty && !closestSafe(target, 'cart-remove-button')) {
      track('quantity_changed', { quantity_direction: qty.classList.contains('qtyplus') ? 'increase' : 'decrease' });
      return;
    }

    if (closestSafe(target, '#cart-icon-bubble, a.header__icon--cart') && document.querySelector('cart-drawer')) {
      track('cart_drawer_opened');
    }
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.matches('.mh-week-picker input[type="radio"]')) {
      track('delivery_week_selected');
      send('set', 'funnel_stage', 'delivery_week_selected');
      return;
    }

    if (target.matches('.quantity__input') && target.closest('cart-items, cart-drawer-items, cart-drawer')) {
      track('quantity_changed', { quantity_direction: 'typed' });
    }
  }, true);

  /* Masking: Clarity masks everything inside an element marked data-clarity-mask="True",
     including text added later. Recipient names, addresses, phone numbers, gift messages
     and Giftship fields are personal, so they are masked whatever the project's masking mode. */
  var MASK_SELECTOR = [
    'cart-address-manager',
    '[data-dest-panel]',
    '.cart-dest-card',
    '.cart-dest-recap',
    '.cart-drawer-giftship',
    '#gsAppContainer',
    '.gs__app-container',
    '.mh-week-picker',
    'form[action*="/cart/add"] input[type="email"]',
    'input[type="tel"]',
    'input[autocomplete*="cc-"]',
    'input[autocomplete*="address"]',
    'input[autocomplete="name"]',
    'input[autocomplete="given-name"]',
    'input[autocomplete="family-name"]',
    'input[autocomplete="email"]',
    'input[autocomplete="tel"]',
    'textarea[data-field="gift_message"]'
  ].join(',');

  function applyMasks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(MASK_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-clarity-mask') !== 'True') {
        nodes[i].setAttribute('data-clarity-mask', 'True');
      }
    }
  }

  var maskTimer = null;
  function scheduleMasks() {
    if (maskTimer) return;
    maskTimer = setTimeout(function () {
      maskTimer = null;
      applyMasks(document);
    }, 150);
  }

  function start() {
    applyMasks(document);
    trackPageStage();
    if (document.body && typeof MutationObserver === 'function') {
      new MutationObserver(scheduleMasks).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
